"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uxUtils = require("@site/ux-utils");
var _reactMintl = require("@godaddy/react-mintl");
var _TickerTape = require("./styles/TickerTape");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ToolTipWrapper = require("./ToolTipWrapper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TickerItemBody = ({
  items,
  prefix,
  isMobile,
  tickerTrackRef
}) => {
  const onTooltipOpen = () => {
    if (tickerTrackRef.current) {
      tickerTrackRef.current.focus();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, items.map(item => /*#__PURE__*/_react.default.createElement(_TickerTape.TickerItem, {
    "data-cy": "ticker-item",
    "data-testid": "ticker-item",
    key: `ticker-item-${prefix}-${item?.text}`,
    isMobile: isMobile
  }, item.icon && /*#__PURE__*/_react.default.createElement(_TickerTape.TickerIcon, null, (0, _uxUtils.getIcon)({
    icon: item.icon,
    iconSize: isMobile ? 18 : 24
  })), /*#__PURE__*/_react.default.createElement(_TickerTape.TickerText, {
    bold: item.bold
  }, item.tooltip?.content ? /*#__PURE__*/_react.default.createElement(_ToolTipWrapper.TooltipWrapper, {
    tooltipContent: item.tooltip.content,
    id: item.text,
    tooltipLabelText: item.text,
    onOpen: onTooltipOpen
  }) : /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: item.text
  })))));
};
TickerItemBody.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    icon: _propTypes.default.string,
    bold: _propTypes.default.bool
  })),
  prefix: _propTypes.default.string,
  isMobile: _propTypes.default.bool,
  tickerTrackRef: _propTypes.default.object
};
const TickerTape = ({
  items = [],
  direction = 'left',
  delay = 20,
  backgroundColor
}) => {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const tickerTrackRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react.default.createElement(_TickerTape.TickerContainer, {
    "data-cy": "ticker-container",
    "data-testid": "ticker-container",
    isMobile: isMobile,
    backgroundColor: backgroundColor
  }, /*#__PURE__*/_react.default.createElement(_TickerTape.TickerTrack, {
    ref: tickerTrackRef,
    direction: direction,
    delay: delay,
    "data-cy": "ticker-track",
    "data-testid": "ticker-track",
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement(_TickerTape.TickerContent, null, /*#__PURE__*/_react.default.createElement(TickerItemBody, {
    items: items,
    prefix: "original",
    isMobile: isMobile,
    tickerTrackRef: tickerTrackRef
  })), /*#__PURE__*/_react.default.createElement(_TickerTape.TickerContent, null, /*#__PURE__*/_react.default.createElement(TickerItemBody, {
    items: items,
    prefix: "duplicate",
    isMobile: isMobile,
    tickerTrackRef: tickerTrackRef
  }))));
};
TickerTape.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.string,
    icon: _propTypes.default.string,
    bold: _propTypes.default.bool
  })),
  direction: _propTypes.default.string,
  delay: _propTypes.default.number,
  backgroundColor: _propTypes.default.string
};
var _default = exports.default = TickerTape;